import { render, staticRenderFns } from "./CustomVueTable.vue?vue&type=template&id=713bc65c&"
import script from "./CustomVueTable.vue?vue&type=script&lang=js&"
export * from "./CustomVueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports